module.exports = __webpack_public_path__ + "static/media/c++.fa6891f4.svg";